import { createSelector } from 'reselect';

import type { State } from 'reducers';
import { LocationState } from 'entities/location/reducer';

const sortFunction = (a: { name: string }, b: { name: string }): number =>
  a.name.localeCompare(b.name);

const selectLocationState = (state: State): LocationState => state.get('entities').location;

export const selectLocations = createSelector(selectLocationState, (locations) =>
  locations.sort(sortFunction)
);
